"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = require("babel-runtime/core-js/object/assign");

var _assign2 = _interopRequireDefault(_assign);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _common = require("../../../utils/common");

var _common2 = _interopRequireDefault(_common);

var _env = require("../../../utils/env");

var _env2 = _interopRequireDefault(_env);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var userBasicDetailsController = function () {
  function userBasicDetailsController(UsersService, NotificationService, AppContextService) {
    "ngInject";

    (0, _classCallCheck3.default)(this, userBasicDetailsController);
    this.usersService = UsersService;
    this.appContextService = AppContextService;
    this.notificationService = NotificationService;
    this.imageBaseUrl = _env2.default.getStorageUrl() + "images/";
    this.videoBaseUrl = "//jugglestreet.wistia.com/medias/";

    this.editMode = {
      firstName: {
        active: false,
        value: ""
      },
      lastName: {
        active: false,
        value: ""
      },
      email: {
        active: false,
        value: ""
      },
      phoneNumber: {
        active: false,
        value: ""
      },
      dateOfBirth: {
        active: false,
        value: "",
        isLoading: false
      },
      affiliateCode: {
        active: false,
        value: "",
        isLoading: false
      }
    };

    this.datePickerOptions = {
      format: "dd/MM/yyyy"
    };
  }

  (0, _createClass3.default)(userBasicDetailsController, [{
    key: "enableEditMode",
    value: function enableEditMode(field) {
      this.editMode[field].active = true;

      // Save the field incase if you want to revert the changes
      this.editMode[field].value = this.user[field];
    }
  }, {
    key: "disableEditMode",
    value: function disableEditMode(field) {
      this.editMode[field].active = false;

      // Revert the changes
      this.user[field] = this.editMode[field].value;
    }
  }, {
    key: "saveDetails",
    value: function saveDetails(field) {
      var _this = this;

      this.editMode[field].isLoading = true;
      var payload = (0, _assign2.default)({}, this.user);

      if (field == "dateOfBirth") {
        var arr = payload.dateOfBirth.split("/");

        payload.dateOfBirthDay = parseInt(arr[0]);
        payload.dateOfBirthMonth = parseInt(arr[1]);
        payload.dateOfBirthYear = parseInt(arr[2]);
      }

      this.usersService.updateUserDetails(this.user.userId, payload, function (response) {
        _this.editMode[field].isLoading = false;
        _this.editMode[field].active = false;
        _this.notificationService.success("Update Successful");
        _this.user = response.data;
      }, function (error) {
        _this.notificationService.error("Update Failed");
        _this.editMode[field].isLoading = false;
      });
    }
  }, {
    key: "formatDate",
    value: function formatDate(date) {
      if (!date) return "-";

      return _common2.default.formatDate(date, "DD/MM/YYYY");
    }
  }, {
    key: "hasPaymentsAdminAccess",
    value: function hasPaymentsAdminAccess() {
      var appContext = this.appContextService.getAppContext();
      if (!appContext) return false;

      if (this.appContextService.hasPaymentsAdminAccess(appContext.roles)) return true;else return false;
    }
  }]);
  return userBasicDetailsController;
}();

exports.default = userBasicDetailsController;


/** WEBPACK FOOTER **
 ** ./client/app/common/Components/user-basic-details/user-basic-details.controller.js
 **/